<template>
	<div class="row">
		<LoadingSpinner v-if="loading_dose"/>
		<div v-else class="col-12">
			<h4 v-if="stallion">{{ $t('monte.stock_semence.utilisation_doses_for') }} {{ stallion.horse_nom }} X {{ mare.horse_nom }}</h4>

			<table class="table table-variante mt-4">
				<tr v-if="doses.length > 0">
					<th>{{ $t('table.semence_doses.semencedose_date') }}</th>
					<th>{{ $t('table.semence_doses.semencedose_volume') }}</th>
					<th>{{ $t('table.semence_doses.solde') }}</th>
					<th>{{ $t('monte.stock_semence.utilisation') }}</th>
				</tr>
				<tr v-for="dose in doses" :key="dose.semencedose_id">
					<td>{{ formatDate(dose.semencedose_date) }}</td>
					<td>{{ dose.semencedose_volume }}</td>
					<td>{{ dose.solde }}</td>
					<td>
						<div class="form-group">
							<b-form-input
								v-model="dose.used"
								type="number"
								value="0"
								:max="dose.solde"
							>
							</b-form-input>
						</div>
					</td>
				</tr>
			</table>

			<div class="text-center">
            	<button @click="submitForm" class="btn btn-primary rounded-pill">
            		<font-awesome-icon v-if="processing" :icon="['fas', 'spinner']" pulse />
                    <font-awesome-icon v-else :icon="['far', 'save']" /> {{ $t('global.valider') }}
                </button>
            </div>
		</div>
	</div>
</template>

<script type="text/javascript">
import Actes from '@/mixins/Actes'
import Gynecologie from '@/mixins/Gynecologie'
import Congelation from '@/mixins/Congelation'
import Shutter from '@/mixins/Shutter'
import { EventBus } from 'EventBus'

export default {
	name: 'ConsommationDoses',
	mixins: [Actes, Gynecologie, Congelation, Shutter],
	props: {
		actes_ids: { type: Array, default: () => [] },
		next: { type: Array, default: () => [] },
		horses_ids: { type: Array, default: () => [] },
		from: { type: String, default: () => ''}
	},
	data () {
		return {
			stallion: null,
			mare: null,
			doses: [],
			loading_dose: false,
			processing: false,
			date: new Date()
		}
	},

	mounted() {
		this.init_component()
	},

	methods: {
		async init_component() {
			this.$sync.force(true)
			this.loading_dose = true
			const acte = await this.getActeFromId(this.actes_ids[0])

			const sms_id = acte.reponse.reponse_hidden_data.find(rep => rep && rep.type == "season_mare_stallion")
			if(!sms_id) this.cancel()
			const sms = await this.loadSeasonMareStallion(sms_id.id)

			this.date = acte.actes_date
			
			this.stallion = sms.horse
			this.mare = sms.mare.horse

			const doses = await this.getDosesByStallion(this.stallion.horse_id, new Date(this.date.getFullYear(), 0, 1), new Date(this.date.getFullYear(), 11, 31))
			this.doses = doses.map(dose => ({...dose, used: 0}))

			// if(this.actes_ids[0] < 0) {
			// 	await this.$sync.force(true, true)
			// }
			// const acte_id = this.$sync.replaceWithReplicated('horse_actes', this.actes_ids[0])
			// this.stocks_used = await this.loadStockUsedByActe(acte_id)
			// this.stocks_used.forEach(s => s.cancel = false)

			this.loading_dose = false
		},

		async submitForm() {
			this.processing = true

			const acte_id = this.$sync.replaceWithReplicated('horse_actes', this.actes_ids[0])

			const dose_used = this.doses.filter(d => d.used != 0)
			const dose_formatted = dose_used.map(d => {
				return {
					id: d.semencedose_id,
					used: d.used,
					acte: acte_id,
					date: this.date
				}
			})

			if(dose_formatted.length > 0) {
				await this.useDoses(dose_formatted)
			}

            if(this.next.length > 0) {
				this.processing = false
				this.successToast("toast.info_modif_succes")
                const triggered = this.next[0]
                this.next.shift()
                this.shutterPanel().close('consommation_dose')
                this.setupNewTriggered(triggered.horses, triggered.date, triggered.type, this.horses_ids[0], this.next, this.from)
            } else if(this.$route.name == 'HorseGynecologie') {
				await this.$sync.force(true)
				EventBus.$emit('GynecologieHorse::reload')
				EventBus.$emit('HorseFiche::refreshHorseStatus')
				this.processing = false
				this.successToast("toast.info_modif_succes")
				this.shutterPanel().close('consommation_dose')
            } else if(this.$route.name == 'planning') {
				await this.$sync.force(true)
				EventBus.$emit('Planning::refreshTable')
				this.processing = false
				this.successToast("toast.info_modif_succes")
				this.shutterPanel().close('consommation_dose')
			} else if (this.$route.params.from == 'acteListe') {
				this.processing = false
				this.successToast("toast.info_modif_succes")
				this.$router.push({ name: 'acteListe'})
			} else { 
				this.processing = false
				this.successToast("toast.info_modif_succes")
				let horse_id = this.$sync.replaceWithReplicated('horse', this.horses_ids[0])
                this.$router.push({ name: 'HorseFichePlanning', params: {horse_id} })
            }
		}
	},

	components: {
		LoadingSpinner: () => import('GroomyRoot/components/Logos/LoadingSpinner_35')
	}
}

</script>